module.exports = __webpack_public_path__ + "static/media/0048.c31f5d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48106/RAL/0048.png
// module id = 2581
// module chunks = 0